import React from 'react';
import CVeng from '../../assets/cvRominaMolina(en).pdf.pdf';
import CVspa from '../../assets/cvRominaMolina(es).pdf.pdf';

const CTA = () => {
  return (
    <div className="flex gap-7 mt-20 justify-center w-full">
      <a href={CVspa} className="btn-home">CV (Spanish)</a>
      <a href={CVeng} className="btn-home">CV (English)</a>
      <a href="#contact" className="btn-home">Contact me!</a>
    </div>
  );
};

export default CTA;
